import { createColumnHelper } from "@tanstack/react-table";
import { qtyDisplay } from "@icraftx/shared/v1";
import { DocNumberLink } from "@/modules/core/components/DocNumberLink";
import type { DeskTableFeatures } from "@/modules/shell/data-table";
import type { InventoryBalanceRow } from "@/shared/api/inventory";
import { RedactedMoney } from "@/shared/feedback/redacted-value";

const columnHelper =
  createColumnHelper<DeskTableFeatures, InventoryBalanceRow>();

export function inventoryBalanceColumns(companySlug: string) {
  return columnHelper.columns([
    columnHelper.accessor("productName", {
      id: "productName",
      header: "Product",
      size: 220,
      cell: (info) => (
        <DocNumberLink
          to={`/c/${companySlug}/products/${info.row.original.productId}`}
          className="font-sans"
        >
          {info.getValue()}
        </DocNumberLink>
      ),
    }),
    columnHelper.accessor("sku", {
      id: "sku",
      header: "SKU",
      size: 120,
      cell: (info) => {
        const sku = info.getValue();
        if (!sku) return "—";
        return (
          <DocNumberLink
            to={`/c/${companySlug}/products/${info.row.original.productId}`}
          >
            {sku}
          </DocNumberLink>
        );
      },
    }),
    columnHelper.accessor("barcode", {
      id: "barcode",
      header: "Barcode",
      size: 140,
      enableSorting: false,
      cell: (info) => info.getValue() || "—",
    }),
    columnHelper.accessor("warehouseCode", {
      id: "warehouseCode",
      header: "Warehouse",
      size: 120,
      cell: (info) => {
        const row = info.row.original;
        return <span title={row.warehouseName}>{info.getValue()}</span>;
      },
    }),
    columnHelper.accessor("qty", {
      id: "qty",
      header: "Qty",
      size: 100,
      cell: (info) => (
        <span className="font-mono tabular-nums">
          {qtyDisplay(info.getValue())}
        </span>
      ),
    }),
    columnHelper.accessor("avgCost", {
      id: "avgCost",
      header: "Avg cost",
      size: 110,
      meta: { align: "right" },
      cell: (info) => <RedactedMoney value={info.getValue()} />,
    }),
  ]);
}
